// domains from https://support.atlassian.com/organization-administration/docs/ip-addresses-and-domains-for-atlassian-cloud-products/
export const TRUSTED_ROOT_DOMAINS: string[] = [
	'atl-paas.net',
	'atlassian.com',
	'atlassian.net',
	'ss-inf.net',
	'jira.com',
	'bitbucket.org',
	'atlassian-us-gov-mod.com',
	'atlassian-us-gov-mod.net',
];
